import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ab-gravatar",
  templateUrl: "./gravatar.component.html",
})
export class GravatarComponent implements OnInit {
  @Input() public user: any;
  @Input() public size: number;
  public initial: any;
  public default: string;
  public url: string;

  public ngOnInit() {
    this.size = this.size || 34;
    this.initial =
      this.user && this.user.nameOrEmail
        ? this.user.nameOrEmail.charAt(0).toUpperCase()
        : "A";

    this.default = "blank";
    this.url =
      this.user != null
        ? `//gravatar.com/avatar/${this.user.gravatarId}.jpg`
        : "//gravatar.com/avatar/";
  }
}
